import { addWeeks, addMonths, addYears, startOfDay, format } from "date-fns";

/** Advance a date by one step of the given frequency. */
export function advanceDate(date: Date, frequency: string): Date {
  switch (frequency) {
    case "weekly":    return addWeeks(date, 1);
    case "bi-weekly": return addWeeks(date, 2);
    case "monthly":   return addMonths(date, 1);
    case "quarterly": return addMonths(date, 3);
    case "annually":  return addYears(date, 1);
    default:          return addMonths(date, 1);
  }
}

/**
 * Compute scheduled dates from a start date, split into backfill (past) and upcoming (future).
 * Returns the next generation date (first entry in upcoming).
 */
export function getScheduledDates(startDate: string, frequency: string) {
  const today = startOfDay(new Date());
  let cursor = startOfDay(new Date(startDate + "T00:00:00"));
  const backfill: string[] = [];

  while (cursor < today) {
    backfill.push(format(cursor, "yyyy-MM-dd"));
    cursor = advanceDate(cursor, frequency);
  }

  const upcoming: string[] = [];
  for (let i = 0; i < 6; i++) {
    upcoming.push(format(cursor, "yyyy-MM-dd"));
    cursor = advanceDate(cursor, frequency);
  }

  return { backfill, upcoming, nextGenerationDate: upcoming[0] };
}
